import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import type { Project } from '../../../../shared/model-typings';

function getProjectGroup(projectGroupId: number) {
  return get<Array<Project['locator']>>(`/api/project_group/${projectGroupId}/all_projects`, true);
}

const getQueryKey = (releaseGroupId: number): QueryKey => ['project_group', releaseGroupId, 'all_projects'];

/**
 * Fetch a list of project locators included a release group by its id.
 *
 * @param {number} releaseGroupId - The id of the release group.
 */
export default function useReleaseGroupAllProjects(
  releaseGroupId: number,
  isEnabled: boolean = true,
) {
  return useQuery({
    queryKey: getQueryKey(releaseGroupId),
    queryFn: () => getProjectGroup(releaseGroupId),
    enabled: isEnabled,
  });
}
